module.exports = __webpack_public_path__ + "static/media/bg-factory.2063f230.png";